import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
    name: 'filterRoom'
})
export class FilterMeetingRoomPipe implements PipeTransform {
    transform(items: any[], searchtext: string): any[] {
        if (!items) return [];
        if (!searchtext) return items;
        searchtext = searchtext.toLowerCase();
        return items.filter(it => {
            return it.meetingRoom.name.toLowerCase().includes(searchtext);
        });
    }
}
